import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import map from 'lodash/map';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toastr } from 'react-redux-toastr';
import Button from 'react-bootstrap-button-loader';
import { setLoader, removeLoader } from '../../../actions';
import { AdvertiserApi } from '../../../api';
import { SearchJobs, AdDetailsForm, ManualForm } from '../../../components/advertisers/ads/';
import { convertMillsToDollars, convertDollarsToMills } from '../../../utils/helpers/currency';

class New extends Component {
  state = {
    showNoCampaignError: false,
    showNoJobsError: false,
    selectedCreateOption: 'fromJobs',
    jobSearchValue: '',
    selectedJobs: [],
    selectedCampaign: '',
    selectedAdDetail: {},
    currentJobResults: []
  };

  componentDidMount() {
    this.fetchResources({
      filters: {
        effective_status: {
          predicate: 'exclude',
          value: ['campaign_removed', 'campaign_ended']
        }
      }
    });
  }

  componentDidUpdate(prevProps) {
    const currentCampaignRef = this.props.location.query.campaign_id;
    const prevCampaignRef = prevProps.location.query.campaign_id;

    if (currentCampaignRef !== prevCampaignRef) {
      this.setCampaignFromParams();
    }
  }

  onSelectCampaignChange(value) {
    const { dispatch, account } = this.props;
    dispatch(push(`/advertiser/home/accounts/${account.slug}/ads/new?campaign_id=${value.value}`));
    this.setState({ selectedCampaign: parseInt(value.value, 10), showNoCampaignError: false });
  }

  onSelectFormChange(value) {
    this.setState({ selectedCreateOption: value.value });
  }

  onSubmitAdsToCampaigns() {
    const { dispatch, account } = this.props;
    const { selectedJobs, selectedCampaign, selectedCreateOption } = this.state;
    if (selectedCreateOption === 'fromManual') return;
    this.validateCampaign();
    if (account.uuid && selectedCampaign) {
      dispatch(setLoader('adManualForm'));
      selectedJobs.forEach((job) => {
        const clonedJob = { ...job };
        delete clonedJob.referencenumber;
        const args = {
          ...clonedJob,
          account_id: account.id,
          campaign_id: selectedCampaign,
          ad_format: job.video_url ? 'video' : 'text',
          location: job.location || `${job.city}, ${job.state}, ${job.country}`,
        };
        dispatch(AdvertiserApi.actions.adCreate.postMultiple(args, (_resolve, _reject, jqXHR) => {
          if (jqXHR) {
            this.removeAdFromSelectedCreate(job);
          }
        }, (_resolve, _reject, e) => {
          if (e) {
            toastr.warning(`${job.title} was unable to be created. Please verify information and try again.`);
          }
        }));
      });
    }
  }

  onManualFormSubmit(values) {
    const { dispatch, account } = this.props;
    const { selectedCampaign, selectedCreateOption } = this.state;
    if (selectedCreateOption === 'fromJobs') return;
    this.validateCampaign();
    if (account.uuid && selectedCampaign) {
      dispatch(setLoader('adDetailsForm'));
      const args = {
        ...values,
        account_id: account.uuid,
        campaign_id: selectedCampaign,
        ad_format: values.video_url ? 'video' : 'text',
        bid: convertDollarsToMills(values.bid),
        category: values.category.value
      };
      dispatch(AdvertiserApi.actions.adCreate.post(args, (error, success) => {
        dispatch(removeLoader('adDetailsForm'));

        if (success) {
          toastr.success('Ad successfully created');
          dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/${selectedCampaign}`));
        }
      }));
    }
  }

  setCampaignFromParams() {
    if (this.props.location.query.campaign_id) {
      this.setState({ selectedCampaign: parseInt(this.props.location.query.campaign_id, 10) });
    }
  }

  validateCampaign() {
    const { selectedCampaign, selectedJobs, selectedCreateOption } = this.state;
    if (!selectedCampaign) {
      toastr.error('No Campaign chosen');
      this.setState({ showNoCampaignError: true });
    }

    if (selectedCreateOption === 'fromJobs' && selectedJobs.length < 1) {
      toastr.error('No jobs selected');
      this.setState({ showNoJobsError: true });
    }
  }

  addJobs(job) {
    const { selectedJobs } = this.state;
    if (job.isSelected) return;
    this.setState({ selectedJobs: [...selectedJobs, job], showNoJobsError: false }, () => {
      this.checkJobs();
    });
    toastr.success(`${job.title} added to drafts`);
  }

  fetchResources(params = {}) {
    const { account, dispatch } = this.props;

    if (account.uuid) {
      const data = { ...params, account_id: account.uuid };

      dispatch(AdvertiserApi.actions.campaigns.get(data, (error, success) => {
        if (success) {
          this.setCampaignFromParams();
        }
      }));
    }
  }

  fetchJobs(params = {}, cb) {
    const { dispatch, account } = this.props;
    const data = { ...params, account_id: account.uuid, per_page: 5 };

    if (account.uuid) {
      dispatch(AdvertiserApi.actions.jobs.get(data, (error, success) => {
        if (success) {
          this.checkJobs();
          cb();
        }
      }));
    }
  }

  fetchCategories() {
    const { dispatch, account } = this.props;
    const { jobSearchValue } = this.state;

    const data = { query: jobSearchValue, account_id: account.uuid };

    if (account.uuid) {
      dispatch(AdvertiserApi.actions.jobs.get(data));
    }
  }

  checkJobs() {
    const { selectedJobs } = this.state;
    const { jobs } = this.props;

    if (jobs) {
      const selectedJobsRef = map(selectedJobs, 'referencenumber');
      const newResults = jobs.data.map((job) => {
        return (
          selectedJobsRef.includes(job.referencenumber) ?
            { ...job, isSelected: true } : { ...job, isSelected: false }
        );
      });
      this.setState({ currentJobResults: newResults });
    }
  }

  saveAdDraft(values) {
    const { selectedJobs } = this.state;
    const selectedJobsWithDraft = selectedJobs.map((adDraft) => {
      return adDraft.referencenumber === values.referencenumber ?
        { ...values, bid: convertDollarsToMills(values.bid) } :
        adDraft;
    });

    this.setState({ selectedJobs: selectedJobsWithDraft, selectedAdDetail: {} }, () => {
      toastr.success('Ad draft successfully saved');
    });
  }

  removeAdFromSelectedCreate(ad) {
    const { dispatch, account } = this.props;
    const { selectedJobs, selectedAdDetail, selectedCampaign } = this.state;
    const newSelectedJobs = selectedJobs.filter((job) => ad.referencenumber !== job.referencenumber);
    if (selectedAdDetail.referencenumber === ad.referencenumber) {
      this.setState({ selectedAdDetail: {} });
    }
    if (newSelectedJobs.length > 0) {
      this.setState({ selectedJobs: newSelectedJobs }, () => this.checkJobs());
    } else {
      toastr.success('Ads successfully created');
      dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/${selectedCampaign}`));
    }
  }

  removeAdFromSelected(ad) {
    const { selectedJobs, selectedAdDetail } = this.state;
    const newSelectedJobs = selectedJobs.filter((job) => ad.referencenumber !== job.referencenumber);
    this.setState({ selectedJobs: newSelectedJobs }, () => this.checkJobs());
    if (selectedAdDetail.referencenumber === ad.referencenumber) {
      this.setState({ selectedAdDetail: {} });
    }
    toastr.success(`${ad.title} successfully removed`);
  }

  selectAdForEditing(ad) {
    this.setState({ selectedAdDetail: ad });
  }

  render() {
    const { campaigns, isLoading } = this.props;
    const {
      selectedCreateOption,
      selectedCampaign,
      selectedAdDetail,
      selectedJobs,
      currentJobResults,
      showNoCampaignError,
      showNoJobsError
    } = this.state;
    const createOptions = [
      { value: 'fromJobs', label: 'Create Ads from Job Inventory' },
      { value: 'fromManual', label: 'Create Ad manually' }
    ];

    const campaignOptions = campaigns.data ? campaigns.data.map((campaign) => {
      return { value: campaign.id, label: campaign.name };
    }) : [];

    const generateIndividualJob = (job) => {
      return (
        <div
          key={job.referencenumber}
          className={
            `selected-job-item ${job.hasError ? 'has-error' : ''} ${job.referencenumber === selectedAdDetail.referencenumber ? 'selected' : ''}`
          }
        >
          <div
            onClick={() => this.selectAdForEditing(job)}
          >
            <h5>{job.title}</h5>
            <span className='job-sub-heading'>{job.company}</span>
            <span className='job-sub-heading'>{job.location ? `${job.location}` : `${job.city}, ${job.state}`}</span>
          </div>
          <div className='selected-job-delete'>
            <FontAwesomeIcon
              icon='trash'
              onClick={() => this.removeAdFromSelected(job)}
            />
          </div>
        </div>
      );
    };

    const generateSelectedJobs = () => {
      return (
        selectedJobs.map((job) => {
          return (
            generateIndividualJob(job)
          );
        })
      );
    };

    const fillAdDetail = (adDraft) => {
      return (
        <div
          className='selected-ad-edit'
        >
          <Row>
            <AdDetailsForm
              onSubmit={this.saveAdDraft.bind(this)}
              initialValues={{ 
                  ...adDraft, 
                  location: adDraft.location || `${adDraft.city}, ${adDraft.state}`,
                  bid: convertMillsToDollars(adDraft.bid)
              }}
              enableReinitialize
            />
          </Row>
        </div>
      );
    };

    const fromJobsForm = () => {
      return (
        <div style={{ marginTop: '20px' }}>
          <Row ref={(node) => (this.node = node)}>
            <Col md={12}>
              <SearchJobs
                jobsSearch={this.fetchJobs.bind(this)}
                addJob={this.addJobs.bind(this)}
                removeJob={this.removeAdFromSelected.bind(this)}
                jobList={currentJobResults}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col md={5}>
              <ControlLabel className={`${showNoJobsError ? 'no-selected' : ''}`}>
                Draft Ads
              </ControlLabel>
              <div
                style={{
                  height: '600px',
                  border: '1px solid', 
                  borderColor: showNoJobsError ? '#ED5565' : '#e5e6e7', 
                  overflowY: 'scroll', 
                  overflowX: 'hidden' 
                }}
              >
                { selectedJobs.length > 0 ? generateSelectedJobs() : 
                  <h5 style={{ marginLeft: '10px' }}>Search for a job in your job inventory to begin.</h5> }
              </div>
              {
                showNoJobsError && <span
                  className='no-selected help-block'
                >
                  Required
                </span>
              }
            </Col>
            <Col md={6} mdOffset={1}>
              <ControlLabel>
                Ad Details
              </ControlLabel>
              <div style={{ height: '600px', border: '1px solid #e5e6e7', overflowY: 'scroll', overflowX: 'hidden', padding: '0 10px' }}>
              { 
              selectedAdDetail.referencenumber ? 
                fillAdDetail(selectedAdDetail) :
                <h5>Select an ad draft to see the details</h5>
              }
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col xs={12}>
              <div style={{ textAlign: 'right' }}>
                <Button  
                  onClick={this.onSubmitAdsToCampaigns.bind(this)}
                  bsStyle='primary'
                  loading={isLoading}
                >
                  Add Ads to Campaign
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );
    };

    const fromManualForm = () => {
      return (
        <div style={{ marginTop: '20px' }}>
          <ManualForm 
            fetchCategories={this.fetchCategories.bind(this)}
            onSubmit={this.onManualFormSubmit.bind(this)}
          />
        </div>
      );
    };

    return (
      <div className='ibox'>
        <div className='ibox-title border-bottom'>
          <Row>
            <Col sm={12}>
              <h5>New Ad</h5>
            </Col>
          </Row>
        </div>
        <div className="ibox-content">
          <Row>
            <Col md={5}>
              <ControlLabel className={`${showNoCampaignError ? 'no-selected' : ''}`}>Campaign Name:</ControlLabel>
              <Select 
                className={`${showNoCampaignError ? 'no-selected' : ''}`}
                onChange={this.onSelectCampaignChange.bind(this)} 
                value={selectedCampaign}
                options={campaignOptions}
                clearable={false}
                placeholder='Select an Existing Campaign'
              />
              {
                showNoCampaignError && <span
                  className='no-selected help-block'
                >
                  Required
                </span>
              }
            </Col>
          </Row>
        <hr />
          <Row>
            <Col md={5}>
              <Select 
                onChange={this.onSelectFormChange.bind(this)} 
                options={createOptions}
                value={selectedCreateOption}
                clearable={false}
              />
            </Col>
          </Row>

          {selectedCreateOption === 'fromJobs' && fromJobsForm()}
          {selectedCreateOption === 'fromManual' && fromManualForm()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { 
    advertiser: { 
      accounts, 
      campaigns: {
        data: campaigns, loading: campaignIsLoading
      },
      jobs: {
        data: jobs, loading: jobIsLoading
      }
    } 
  } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};

  return {  
    account,
    campaigns,
    campaignIsLoading,
    jobs,
    jobIsLoading
  };
};

export default connect(mapStateToProps)(New);
